<template>
  <v-container fluid>
    <div v-if="subscriptionPending" class="text-center mt-8">
      <AppLoader></AppLoader>
    </div>
    <template v-else-if="canAccessConsumption">
      <!-- Title -->
      <v-row>
        <v-col>
          <h1>{{ $t('subscriptions.views.SubscriptionConsumption.title') }}</h1>
        </v-col>
      </v-row>

      <!-- Alert Storage Overcharge Enabled -->
      <v-row v-if="isDataroomStorageOverchargeEnabled">
        <v-col cols="12">
          <Alert type="info" :dismissible="false">
            {{ $t('subscriptions.views.SubscriptionConsumption.packageOverchargeIsEnabled') }}
          </Alert>
        </v-col>
      </v-row>

      <!-- Dataroom Storage -->
      <v-row class="mt-4">
        <v-col v-if="hasSubscriptionEnvelopesPacks" cols="12" md="6">
          <SubscriptionConsumptionPacks/>
        </v-col>
        <v-col v-if="hasDataroomStoragePlan" cols="12" md="6">
          <SubscriptionConsumptionDataroomStorage/>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'

  import Alert from '@/common/alerts/Alert.vue'
  import AppLoader from '@/common/AppLoader.vue'

  import SubscriptionConsumptionDataroomStorage from './SubscriptionConsumptionDataroomStorage.vue'
  import SubscriptionConsumptionPacks from './SubscriptionConsumptionPacks.vue'

  export default {
    name: 'SubscriptionConsumption',
    components: {
      AppLoader,
      Alert,
      SubscriptionConsumptionDataroomStorage,
      SubscriptionConsumptionPacks,
    },
    computed: {
      ...mapGetters('subscription', ['hasDataroomStoragePlan', 'hasSubscriptionEnvelopesPacks']),
      ...mapState('subscription', ['subscription', 'subscriptionPending', 'subscriptionDataroomStorage', 'subscriptionConsumptionPacks']),
      canAccessConsumption () {
        return this.hasDataroomStoragePlan || this.hasSubscriptionEnvelopesPacks
      },
      isDataroomStorageOverchargeEnabled () {
        return parseFloat(this.subscriptionDataroomStorage?.limitGbOvercharge) > 0
      },
    },
  }
</script>
